import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import testimonyPhoto from 'assets/img/landing/landing-testimonies.png';
import HeaderButton from '../HeaderButton';
import useMobile from 'utils/useMobile';
import ContentContainer from './ContentContainer';
import ContentContainerMobile from './ContentContainer/mobile';
import VideoPlayer from 'components/VideoPlayer';
import videoUrl from 'config/videoUrl';
const sectionHeight = 560;

const useStyles = makeStyles(({ palette }) => ({
  root: {
    backgroundImage: `url(${testimonyPhoto})`,
    backgroundPosition: 'center',
    backgroundSize: '1450px 813px',
    color: palette.getContrastText(palette.common.black),
    width: '100%',
    height: sectionHeight,
    position: 'relative'
  }
}));

const SectionTransformation = () => {
  const [openPlayer, setOpenPlayer] = useState(false);

  const classes = useStyles({})
;
  const isMobile = useMobile();

  const playerHeight = sectionHeight;
  const onPlayerClose = () => setOpenPlayer(false);

  const ContentComponent = isMobile ? ContentContainerMobile : ContentContainer;
  return (
    <div className={classes.root}>
      <ContentComponent>
        <HeaderButton size="large" onClick={() => setOpenPlayer(true)}>
          watch video now
        </HeaderButton>
      </ContentComponent>
      <VideoPlayer
        open={openPlayer}
        onClose={onPlayerClose}
        height={playerHeight}
        url={videoUrl(process.env.REACT_APP_TRANSFORMATION_VIDEO)}
      />
    </div>
  );
};

export default SectionTransformation;
